<template>
  <div id="projectDetail">
    <div class="topTitle">
      <div class="left">
        <van-image class="img" :src="require('@/assets/images/icon_backArrow_01.png')" @click="$router.go(-1)"></van-image>
      </div>
    </div>
    <div class="box">
      <div class="home-list">
        <ProjectItem class="project-item" :item="detail" />
      </div>
      <div class="box-content">
        <MoreInfo
          v-model="isMore"
          class="more-info"
          :line="3"
          :content="detail.brief"
        ></MoreInfo>
      </div>
    </div>
    <van-tabs v-model="active" class="vanTabs" sticky animated swipeable  @change="tabChange">
      <van-tab :title="`资源(${detail.resourceNum || 0})`" class="tab-item-1">
        <van-pullRefresh v-model="projectResource.refreshing" @refresh="getProjectResource">
          <Empty v-if="projectResource.totalCount === 0" tip="暂无内容" />
          <div  v-else class="resourceWrap">
            <ul class="list">
              <li v-for="item in projectResource.dirs" :key="item.id" class="list-item m-b-20">
                <ResourceItem
                  :projectId="id"
                  type="folder"
                  :item="item"
                />
              </li>
              <li v-for="item in projectResource.files" :key="item.id" class="list-item">
                <ResourceItem :item="item" />
              </li>
            </ul>
          </div>
        </van-pullRefresh>
      </van-tab>
      <van-tab :title="`成员(${detail.memberNum || 0})`" class="tab-item-2">
        <van-pullRefresh v-model="page.refreshing" @refresh="init">
          <div class="memberWrapper">
            <div class="tab-item-top" v-if="getMemberPermissions(2)">
              <router-link tag="div" class="btn" :to="{name:'ProjectMember', params:{id: id}}">
                <van-icon name="add-o" />
                <span>邀请成员</span>
              </router-link>
            </div>
            <Empty v-if="page.totalCount === 0" />
            <van-List
              v-else
              v-model="page.loading"
              :finished="page.finished"
              @load="onLoad"
            >
              <template v-for="item in page.list">
                <ProjectMemberItem
                  v-if="getMemberPermissions(2)"
                  :key="item.id"
                  :item="item"
                  :roleType="detail.memberPermissions"
                  :id="detail.id"
                  @refresh="refresh"
                />
                <PublishTeamMemberItem v-else :key="item.id" :item="item" />
              </template>
              <template #finished>
                <van-divider class="list-bottom-tip">滑到底啦</van-divider>
              </template>
            </van-List>
          </div>
        </van-pullRefresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import ProjectItem from './components/ProjectItem.vue';
import ResourceItem from './components/ResourceItem.vue';
import ProjectMemberItem from './components/ProjectMemberItem.vue';
import PublishTeamMemberItem from './components/PublishTeamMemberItem.vue';
import { MoreInfo } from '@/components';
export default {
  name: 'ProjectDetail',
  components: { ProjectItem, ResourceItem, ProjectMemberItem, PublishTeamMemberItem, MoreInfo },
  data () {
    return {
      id: '',
      detail: {},
      active: 0,
      page: {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      },
      projectResource: {
        dirs: [],
        files: [],
        totalCount: '',
        refreshing: false
      },
      isMore: false
    };
  },
  watch: {
    $route: {
      handler ({ name, params: { id }, query: { active } }) {
        if (name === 'ProjectDetail') {
          this.id = id;
          this.active = active * 1 || 0;
          this.init();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.getDetail();
    this.getProjectResource();
  },
  methods: {
    init () {
      // 清空列表数据 重新加载数据
      this.page = {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      };
    },
    getDetail () {
      const { id } = this;
      this.$http.get('studio/projectDetail', { params: { id }, showLoading: true }).then((res) => {
        this.detail = res.data;

        this.$wxShare({
          // url: window.href, // 网址，默认使用 window.location.href
          title: this.detail.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          desc: this.detail.brief || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          imgUrl: this.detail.defaultImage // 图片, 默认取网页中第一个img标签
        });
      });
    },
    onLoad () {
      const { id, page, active } = this;
      let apiurl = '';
      const params = {
        pageNo: page.pageNo,
        pageSize: page.pageSize
      };
      switch (active) {
        case 0:
          apiurl = 'studio/projectResource';
          params.projectId = id;
          break;
        case 1:
          apiurl = 'studio/projectMemberList';
          params.id = id;
          break;
      }
      this.$http.get(apiurl, { params, showLoading: true }).then((res) => {
        if (active === 0) { // 资源
          const { dirs = [], files = [] } = res.data;
          page.finished = true;
          page.list = [...dirs.map((item) => {
            item.rowType = 1;
            return item;
          }), ...files.map((item) => {
            item.rowType = 2;
            return item;
          })];
        } else { // 成员
          const data = res.data;
          if (!data.isHasNext) {page.finished = true;}
          page.pageNo = data.nextPage;
          page.list.push(...data.result);
        }
        page.loading = false;
        this.page = page;
      });
    },
    getProjectResource () {
      let { projectResource, id } = this;
      projectResource.totalCount = '';
      this.$http.get('studio/projectResource', {
        params: {
          projectId: id
        }
      }).then((res) => {
        let data = res.data;
        projectResource.dirs = data.dirs || [];
        projectResource.files = data.files || [];
        projectResource.refreshing = false;
        projectResource.totalCount = projectResource.dirs.length + projectResource.files.length;
      });
    },
    getMemberPermissions (ruleIndex) {
      // memberPermissions 1：项⽬负责⼈2：普通项⽬成员3：项⽬管理员4：顾问5：未加⼊项⽬的普通⼯作室成员6：游客
      let rule = {
        1: [1, 2, 3],
        2: [1, 3],
        3: [1],
        4: [3],
        5: [4],
        6: [5]
      };
      let { memberPermissions } = this.detail;
      return rule[ruleIndex].indexOf(memberPermissions) > -1;
    },
    tabChange (e) {
      this.onReplace({
        active: e
      });
    },
    onReplace (params = {}) {
      const { $router } = this;
      $router.replace({
        query: { active: params.active }
      });
    },
    refresh () {
      this.init();
    }

  }
};
</script>

<style scoped lang="less">
  #projectDetail{
    .topTitle{
      width: 100%;
      height: 94px;
      background: #FFFFFF;
      justify-content: space-between;
      padding: 16px 30px;
      align-items: center;
      display: flex;
      .left{
        .img{
          width: 32px;
          height: 32px;
        }
      }
      .right{
        .btn{
          width: 140px;
          height: 56px;
          background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
          border-radius: 8px;
          font-size: 24px;
          line-height: 56px;
          color: #FFFFFF;
          text-align: center;
        }
      }
    }
    .box{
      background-color: #fff;
      width: 100%;
      border-bottom: 40px solid #fff;
      padding: 28px;
      .home-list{
        background: #F7F8FC;
        margin-bottom: 52px;
        .project-item{
          background-color: rgba(247, 248, 252, 1);
        }
      }
      .box-content{
        position: relative;
        display: flex;
        overflow: hidden;
        width: 100%;
        .exp{
          display: none;
          &:checked+.text{
            -webkit-line-clamp: 999;
            .btn{
              &::before{
                content:'收起'
              }
            }
          }
        }
        .text {
          text-align: justify;
          position: relative;
          font-size: 26px;
          line-height: 48px;
          color: #67677A;
          transition: .3s 200px;
          .multi-line-omit(3);
          &::before{
            content: '';
            height: calc(100% - 46px);
            float: right;
          }
          .btn{
            float: right;
            clear: both;
            margin-left: 28px;
            padding: 0 0px 0 28px;
            font-size: 26px;
            line-height: 48px;
            color: #946FFE;
            &::before{
              content:'展开'
            }
          }
        }

        .content{
          font-size: 26px;
          line-height: 48px;
          color: #67677A;
          &.omit{
            .multi-line-omit(3);
          }
        }
        .open{
          font-size: 26px;
          line-height: 48px;
          color: #946FFE;
          position: absolute;
          right: 0;
          bottom: 0;
          width: 100px;
          background: #fff;
          text-align: right;
        }
        .put{
          font-size: 26px;
          line-height: 48px;
          color: #946FFE;
          position: absolute;
          right: 0;
          bottom: -25px;
          text-align: right;
        }
      }
    }
    /deep/
    .van-tabs{
      .van-tabs__line{
        background-image: url('~@/assets/images/icon_tab_green.png');
      }
      .van-tab--active {
        color: @primaryGreen;
      }
    }
    .tab-item-top {
      padding-left: 28px;
      padding-right: 28px;
      margin-bottom: 20px;
      .btn {
        height: 80px;
        font-size: 28px;
        color: @primaryGreen;
        border-radius: 8px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-icon {
          margin-right: 12px;
        }
      }
    }
    .resourceWrap {
      padding: 32px 28px;
      .m-b-20 {
        margin-bottom: 20px;
      }
    }

    .memberWrapper {
      padding-top: 32px;
    }
  }
</style>
